import React, { Fragment, useEffect, useRef } from 'react'
import YearlyBudgerListView from '../../../../components/account/report/year_budger_rpt/YearlyBudgerListView'
import { useDispatch } from 'react-redux';
import { pageTitle } from '../../../../store/softSlice';
import { useReactToPrint } from 'react-to-print';
import { PdfExportBtn } from '../../../../widgets/AppBtn';
import PrintYearlyBudgetReportView from '../../../../components/account/report/year_budger_rpt/PrintYearlyBudgetReportView';


const YearlyBudgetReportListView = ({ PageTitle, setIconsButton }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(pageTitle({ title: PageTitle }));
        document.title = `${PageTitle}`;
        setIconsButton(<PdfExportBtn onClick={handlePrintCard} />);
    }, []);

    const componentListRef = useRef();
    const RenderListComponent = React.forwardRef(() => (
        <PrintYearlyBudgetReportView />
    ));

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current,
    });
    return (
        <Fragment>
            <YearlyBudgerListView />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <RenderListComponent />
                </div>
            </div>
        </Fragment>
    )
}

export default YearlyBudgetReportListView
